import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/actions')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/action' })
  },
})
